import { useAllItems } from "http-hooks/item/useItem";
import DeleteItem from "components/item/DeleteItem";
import { useState } from "react";
import useModalStore from "store/modals";
import InputSearch from "components/ui/InputSearch";
import Select from "components/ui/Select";
import MasterPage, {
  FilterRow,
  FilterCell,
  ClearFiltersButton,
  AddButton,
  StatusIcon,
  EditAction,
  DeleteAction,
} from "components/ui/MasterPage";

const statusOptions = [
  { value: "", label: "All Status" },
  { value: "1", label: "Active" },
  { value: "0", label: "Inactive" },
];

const initialFilter = {
  item_name: "",
  item_code: "",
  ag_status: "",
  page: 1,
  limit: 10,
};

const columns = [
  { key: "item_name", header: "Item Name" },
  { key: "item_code", header: "Item Code" },
  {
    key: "ag_status",
    header: "Status",
    render: (item) => <StatusIcon value={item.ag_status} />,
  },
  { key: "actions", header: "Actions", isActions: true },
];

export default function ItemMaster() {
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [filter, setFilter] = useState(initialFilter);
  const { openModal } = useModalStore();

  const openSetModal = (id) => openModal("item", id);

  const handleSearchName = (searchTerm) => {
    setFilter((prev) => ({ ...prev, item_name: searchTerm, page: 1 }));
  };

  const handleSearchCode = (searchTerm) => {
    setFilter((prev) => ({ ...prev, item_code: searchTerm, page: 1 }));
  };

  const handleStatusChange = (statusOption) => {
    setSelectedStatus(statusOption);
    setFilter((prev) => ({
      ...prev,
      ag_status: statusOption?.value || "",
      page: 1,
    }));
  };

  const clearFilters = () => {
    setSelectedStatus(null);
    setFilter(initialFilter);
  };

  const {
    isLoading,
    data: { data: allitems, page: currentPage, totalPages } = [],
  } = useAllItems(filter);

  return (
    <MasterPage
      title="Raw Items Master"
      headerActions={
        <AddButton onClick={() => openSetModal()}>Add item</AddButton>
      }
      filters={
        <FilterRow>
          <FilterCell>
            <InputSearch
              onSearch={handleSearchName}
              label="Item Name"
              placeholder="Search Item Name"
            />
          </FilterCell>
          <FilterCell>
            <InputSearch
              onSearch={handleSearchCode}
              label="Item Code"
              placeholder="Search Item Code"
            />
          </FilterCell>
          <FilterCell>
            <Select
              value={selectedStatus}
              onChange={handleStatusChange}
              options={statusOptions}
              label="Status"
              placeholder="Select status"
              isClearable={true}
              isSearchable={false}
            />
          </FilterCell>
          <ClearFiltersButton onClick={clearFilters} />
        </FilterRow>
      }
      columns={columns}
      data={allitems}
      isLoading={isLoading}
      rowKey="item_id"
      deleteComponent={DeleteItem}
      renderActions={(item, setDeleteItemId) => (
        <>
          <EditAction
            onClick={() => openSetModal(item.item_id)}
            title="Edit Item"
          />
          <DeleteAction
            onClick={() => setDeleteItemId(item.item_id)}
            title="Delete Item"
          />
        </>
      )}
      pagination={{
        currentPage,
        totalPages,
        onPageChange: (page) => setFilter((prev) => ({ ...prev, page })),
      }}
    />
  );
}
